import { render, staticRenderFns } from "./ResultadoBuscaView.vue?vue&type=template&id=281cc87a&scoped=true"
import script from "./ResultadoBuscaView.vue?vue&type=script&lang=js"
export * from "./ResultadoBuscaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281cc87a",
  null
  
)

export default component.exports